<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const nodeTypes = [
  { type: 'trigger', icon: 'i-lucide-zap', color: 'n-blue' },
  { type: 'message', icon: 'i-lucide-message-square', color: 'n-green' },
  { type: 'block', icon: 'i-lucide-layout-grid', color: 'n-indigo' },
  {
    type: 'data_collection',
    icon: 'i-lucide-clipboard-list',
    color: 'n-violet',
  },
  { type: 'condition', icon: 'i-lucide-git-branch', color: 'n-amber' },
  { type: 'action', icon: 'i-lucide-settings', color: 'n-violet' },
  { type: 'delay', icon: 'i-lucide-clock', color: 'n-amber' },
  { type: 'group', icon: 'i-lucide-box', color: 'n-slate' },
];

const onDragStart = (event, type) => {
  if (!event.dataTransfer) return;
  event.dataTransfer.setData('text/plain', type);
  event.dataTransfer.effectAllowed = 'move';
};
</script>

<template>
  <div class="w-full flex flex-col p-0 gap-2">
    <h3 class="text-xs font-semibold uppercase text-n-slate-11 mb-2">
      {{ t('FLOW_BUILDER.SIDEBAR.TITLE') }}
    </h3>
    <div
      v-for="node in nodeTypes"
      :key="node.type"
      class="flex items-center gap-2 px-3 py-2.5 rounded-lg border border-n-weak dark:border-n-strong cursor-grab hover:bg-n-slate-2 dark:hover:bg-n-slate-3 transition-colors"
      draggable="true"
      @dragstart="onDragStart($event, node.type)"
    >
      <span :class="node.icon" class="text-base" />
      <span class="text-sm font-medium text-n-slate-12">
        {{ t(`FLOW_BUILDER.SIDEBAR.${node.type.toUpperCase()}`) }}
      </span>
    </div>
  </div>
</template>
